import React from 'react';

const CalendarSVG = () => (
  <svg fill="#000000" data-name="Layer 1" viewBox="0 0 100 100" x="0px" y="0px">
    <path d="M70.67,23.35H67.08V20.81a3,3,0,0,0-6,0v2.54H38.92V20.81a3,3,0,0,0-6,0v2.54H29.33a11,11,0,0,0-11,11V71.19a11,11,0,0,0,11,11H70.67a11,11,0,0,0,11-11V34.35A11,11,0,0,0,70.67,23.35Zm-41.33,6h3.59v4.54a3,3,0,0,0,6,0V29.35H61.08v4.54a3,3,0,0,0,6,0V29.35h3.59a5,5,0,0,1,5,5v9.1H24.33v-9.1A5,5,0,0,1,29.33,29.35ZM70.67,76.19H29.33a5,5,0,0,1-5-5V49.45H75.67V71.19A5,5,0,0,1,70.67,76.19Z" />
  </svg>
);

export default CalendarSVG;
